import {atom} from "recoil";

export const creditCardsState = atom({
  key: 'CreditCardsState',
  default: [],
  effects: []
});
